// src/pages/gene.codes/GeneticWheel/dashboardPanels/InterventionsSidebar.tsx
import React from "react";
import { Typography } from "antd";
import { InterventionData } from "../wheels/InterventionsDisplay";
import { EmptyState } from "../../../../components/shared";
import "./dashboardPanels.css";

const { Text } = Typography;

interface CategoryImpact {
	category: string;
	high: number;
	medium: number;
}

// Optional until 86d43hh5k ships them on the labiq payload.
type InterventionDetail = InterventionData & {
	total_score?: number;
	snp_count?: number;
	category_impacts?: CategoryImpact[];
};

interface InterventionsSidebarProps {
	selectedIntervention: InterventionDetail | null;
	isTransitioning?: boolean;
}

const InterventionsSidebar: React.FC<InterventionsSidebarProps> = ({ selectedIntervention, isTransitioning = false }) => {
	if (!selectedIntervention) {
		return (
			<div data-testid="interventions-sidebar" className="mg-interventions-sidebar__empty">
				<EmptyState
					title="Select an intervention"
					description="Click on an intervention segment in the wheel to explore detailed genetic interactions and available analysis panels."
				/>
			</div>
		);
	}

	const categories = selectedIntervention.panels ?? [];
	const snpCount = selectedIntervention.snp_count ?? 0;
	const impacts = selectedIntervention.category_impacts ?? [];

	return (
		<div data-testid="interventions-sidebar" className={isTransitioning ? "mg-interventions-sidebar mg-interventions-sidebar--transitioning" : "mg-interventions-sidebar"}>
			<div className="mg-interventions-sidebar__body">
				<Text className="mg-interventions-sidebar__heading">Areas of benefit</Text>
				<div data-testid="intervention-benefit-summary" className="mg-interventions-sidebar__summary">
					{snpCount} genetic markers across {categories.length} categories
				</div>

				{impacts.length > 0 && (
					<div className="mg-interventions-impacts">
						<div className="mg-interventions-impacts__key">
							<span style={{ color: "var(--mg-danger)" }}>■</span> high impact <span style={{ color: "var(--mg-warning)" }}>□</span> medium impact
						</div>
						{impacts.map((impact) => (
							<div key={impact.category} data-testid="intervention-impact-row" className="mg-interventions-impacts__row">
								<span className="mg-interventions-impacts__category">{impact.category}</span>
								<span className="mg-interventions-impacts__bars">
									<span data-testid="intervention-impact-high" style={{ color: "var(--mg-danger)" }}>{"■".repeat(impact.high)}</span>
									<span data-testid="intervention-impact-medium" style={{ color: "var(--mg-warning)" }}>{"□".repeat(impact.medium)}</span>
								</span>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default InterventionsSidebar;
